import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { Button, Chip } from '@resurs/midas-react'

export class MultiSelect extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      add: this.props.hideButton,
    }
    this.multiSelectRef = React.createRef(null)
  }

  onChange(e, value) {
    e.preventDefault()
    this.setState({ add: this.props.hideButton })
    const val = e.target.value !== '' ? e.target.value : value
    const vals = []
    vals.push(val)
    this.props.onChange([...new Set([...this.props.defaultValues, ...vals])])
  }

  remove(e, value) {
    e.preventDefault()
    const vals = this.props.defaultValues
    vals.splice(value, 1)
    this.setState({ add: this.props.hideButton })
    this.props.onChange(vals)
    this.multiSelectRef.current.selectedIndex = 0
  }

  render() {
    return (
      <div className={midas.formGroup}>
        <label className={midas.formLabel}>{this.props.fieldCaption}</label>
        {this.state.add ? (
          <select
            ref={this.multiSelectRef}
            className={`${midas.formSelect} ${midas.mt10}`}
            onChange={e => this.onChange(e)}
            defaultValue={this.props.fieldCaption}
          >
            <option disabled>{this.props.fieldCaption}</option>
            {this.props.values.map((item, index) => {
              let disabled = null
              if (this.props.disablePlaceHolder && index === 0) {
                disabled = { disabled: true }
              }
              return (
                <option key={item} value={item} {...disabled}>
                  {this.props.names[this.props.values.indexOf(item)]}
                </option>
              )
            })}
          </select>
        ) : (
          this.props.defaultValues.length !== this.props.values.length && (
            <Button
              text={this.props.addText}
              typeName="link"
              icon="midasAdd1"
              onClick={() => this.setState({ add: true })}
            />
          )
        )}
        {this.props.defaultValues.map((item, index) => (
          <Chip
            close
            round={this.props.round}
            onClose={e => this.remove(e, index)}
          >
            {this.props.names[this.props.values.indexOf(item)]}
          </Chip>
        ))}
      </div>
    )
  }
}

MultiSelect.defaultProps = {
  disablePlaceHolder: false,
  hideButton: false,
  round: false,
}

MultiSelect.propTypes = {
  // fieldName: PropTypes.string.isRequired,
  fieldCaption: PropTypes.string.isRequired,
  names: PropTypes.array.isRequired,
  values: PropTypes.array.isRequired,
  defaultValues: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  disablePlaceHolder: PropTypes.bool,
  addText: PropTypes.string.isRequired,
  hideButton: PropTypes.bool,
  round: PropTypes.bool,
}
